import { EventOutcome } from 'crono-fe-common/types/event';

export const OUTCOME_LABELS: Record<EventOutcome, string> = {
  [EventOutcome.Scheduled]: 'Scheduled',
  [EventOutcome.Completed]: 'Completed',
  [EventOutcome.Rescheduled]: 'Rescheduled',
  [EventOutcome.NoShow]: 'No show',
  [EventOutcome.Canceled]: 'Canceled',
};
